import React, { useRef, useState } from 'react'
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'

// import required modules
import { Pagination, Navigation } from 'swiper/modules'
import { AnimateOnScroll } from 'animate-on-scroll-framer'

const DATA = [
  {
    name: 'Acquire First Properties',
    phase: 'Phase 01',
    description: `We're kicking off our journey by utilizing initial funds to acquire our first properties through our decentralized autonomous organization (DAO) setup. This strategy allows us to initiate our portfolio and lay the groundwork for future expansions.`,
  },
  {
    name: 'Monetizing Properties',
    phase: 'Phase 02',
    description: `Shortly after acquisition, we will optimize the properties to generate income from both long and short-term rentals, depending on regional demand. The income generated will be essential in providing a steady cash flow, enabling further strategic actions.`,
  },
  {
    name: 'Revenue Sharing',
    phase: 'Phase 03',
    description: `As soon as the properties begin generating income, which we anticipate will occur a few weeks post-acquisition, we will initiate revenue sharing. This approach is designed to return value to our token holders and sustain their long-term engagement.`,
  },
  {
    name: 'Revenue Sharing',
    phase: 'Phase 03',
    description: `As soon as the properties begin generating income, which we anticipate will occur a few weeks post-acquisition, we will initiate revenue sharing. This approach is designed to return value to our token holders and sustain their long-term engagement.`,
  },
]

export default function Roadmap() {
  return (
    <div
      className='md:px-10 px-5'
      id='roadmap'
    >
      <div className='bg-white md:py-20 py-10'>
        <AnimateOnScroll animation='flipIn'>
          <p className='text-[#545454] text-xl  font-medium text-center'>
            Roadmap
          </p>
        </AnimateOnScroll>
        <AnimateOnScroll animation='flipIn'>
          <h3 className='font-medium text-[40px] text-[#0E0339] text-center'>
            What we Plan Ahead of Us
          </h3>
        </AnimateOnScroll>
        <div className='container  '>
          <Swiper
            navigation={true}
            slidesPerView={1}
            spaceBetween={10}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              480: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 50,
              },
            }}
            modules={[Navigation]}
            className='mySwiper !relative'
          >
            {DATA.map((item, index) => (
              <SwiperSlide key={index}>
                <div className='border border-[#D6C8F3] rounded-[30px] p-10 bg-white'>
                  <h3
                    className='font-medium text-start text-xl text-[#0E0339] 
            '
                  >
                    {item.name}
                  </h3>
                  <p className='bg-[#B7B7B74D] text-[#5D5F61] px-4 py-1 rounded-full w-[130px] my-4'>
                    {item.phase}
                  </p>
                  <p className='text-base text-start text-[#838383] font-extralight'>
                    {item.description}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  )
}
